/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import { Select } from '@react-three/postprocessing'
import { useEffect, useMemo, type JSX } from 'react'
import { Matrix4, Mesh } from 'three'
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

import { useColorMapGLTF } from '@hooks'

interface GLTFResultNodes {
  ['train-carriage-container-blue_1']: Mesh
  ['wheels-front']: Mesh
  ['wheels-back']: Mesh
  cargo: Mesh
}

type WagonContainerBlueModelProps = JSX.IntrinsicElements['group'] & {
  color?: string
  highlight?: boolean
}

export function WagonContainerBlueModel({ highlight, ...props }: WagonContainerBlueModelProps) {
  const { nodes, material } = useColorMapGLTF<GLTFResultNodes>(
    '/models/train/train-carriage-container-blue.glb',
    'train',
  )

  const mergedGeometry = useMemo(() => {
    return mergeGeometries([
      nodes['train-carriage-container-blue_1'].geometry,
      nodes['wheels-front'].geometry
        .clone()
        .applyMatrix4(new Matrix4().makeTranslation(0, 0.359, 0.6)),
      nodes['wheels-back'].geometry
        .clone()
        .applyMatrix4(new Matrix4().makeTranslation(0, 0.359, -0.6)),
      nodes.cargo.geometry.clone().applyMatrix4(new Matrix4().makeTranslation(0, 0.459, 0.037)),
    ])
  }, [nodes])

  useEffect(() => {
    return () => {
      mergedGeometry?.dispose()
    }
  }, [mergedGeometry])

  return (
    <group {...props}>
      <Select enabled={highlight}>
        <mesh castShadow receiveShadow geometry={mergedGeometry} material={material} />
      </Select>
    </group>
  )
}

useGLTF.preload('/models/train/train-carriage-container-blue.glb')
